/**
 * @generated SignedSource<<5df032b037141f302cb6313242045cd1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type utilizationListComponent_Query$variables = {
  shareKey?: string | null;
  dateCriteria?: string | null;
  componentId?: string | null;
  personIds?: ReadonlyArray<string | null> | null;
  teamIds?: ReadonlyArray<string | null> | null;
  roleIds?: ReadonlyArray<string | null> | null;
  labelIds?: ReadonlyArray<string | null> | null;
  projectStatusesBackend?: ReadonlyArray<string | null> | null;
};
export type utilizationListComponent_Query$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"utilizationListComponent_viewer">;
  } | null;
};
export type utilizationListComponent_Query = {
  variables: utilizationListComponent_Query$variables;
  response: utilizationListComponent_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "componentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dateCriteria"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "labelIds"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "personIds"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectStatusesBackend"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "roleIds"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shareKey"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamIds"
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "insight_utilization_list"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"insight_utilization_list\")"
},
v10 = {
  "kind": "Variable",
  "name": "componentId",
  "variableName": "componentId"
},
v11 = {
  "kind": "Variable",
  "name": "dateCriteria",
  "variableName": "dateCriteria"
},
v12 = {
  "kind": "Variable",
  "name": "labelIds",
  "variableName": "labelIds"
},
v13 = {
  "kind": "Variable",
  "name": "personIds",
  "variableName": "personIds"
},
v14 = {
  "kind": "Variable",
  "name": "projectStatusesBackend",
  "variableName": "projectStatusesBackend"
},
v15 = {
  "kind": "Variable",
  "name": "roleIds",
  "variableName": "roleIds"
},
v16 = {
  "kind": "Variable",
  "name": "shareKey",
  "variableName": "shareKey"
},
v17 = {
  "kind": "Variable",
  "name": "teamIds",
  "variableName": "teamIds"
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scheduledProjectTimeMinutes",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scheduledNonProjectTimeMinutes",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "utilizationListComponent_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "args": [
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "utilizationListComponent_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v6/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v7/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "utilizationListComponent_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": [
              (v16/*: any*/)
            ],
            "concreteType": "InsightComponentsDataType",
            "kind": "LinkedField",
            "name": "insightComponentsData",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v17/*: any*/)
                ],
                "concreteType": "UtilizationList",
                "kind": "LinkedField",
                "name": "utilizationList",
                "plural": false,
                "selections": [
                  (v18/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "availableMinutesTotal",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "scheduledMinutesTotal",
                    "storageKey": null
                  },
                  (v19/*: any*/),
                  (v20/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "reportedTotal",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "assignedTasksForecastTotal",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "overTimeMinutesTotal",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billableMinutesRegisteredTotal",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billableMinutesPlannedTotal",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UtilizationListPerson",
                    "kind": "LinkedField",
                    "name": "utilizationListData",
                    "plural": true,
                    "selections": [
                      (v18/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "profilePictureId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "profilePictureDefaultId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "roleName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "availableMinutes",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "scheduledMinutes",
                        "storageKey": null
                      },
                      (v20/*: any*/),
                      (v19/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "reported",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "billableMinutesRegistered",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "billableMinutesPlanned",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cardMinutesPlanned",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v18/*: any*/)
            ],
            "storageKey": null
          },
          (v18/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2e63c7d15d3b617cbb60d7a8db4e980e",
    "id": null,
    "metadata": {},
    "name": "utilizationListComponent_Query",
    "operationKind": "query",
    "text": "query utilizationListComponent_Query(\n  $shareKey: String\n  $dateCriteria: String\n  $componentId: ID\n  $personIds: [ID]\n  $teamIds: [ID]\n  $roleIds: [ID]\n  $labelIds: [ID]\n  $projectStatusesBackend: [ID]\n) {\n  viewer {\n    actualPersonId\n    component(name: \"insight_utilization_list\")\n    ...utilizationListComponent_viewer_1IcmZU\n    id\n  }\n}\n\nfragment utilizationListComponent_viewer_1IcmZU on Viewer {\n  insightComponentsData(shareKey: $shareKey) {\n    utilizationList(dateCriteria: $dateCriteria, personIds: $personIds, componentId: $componentId, teamIds: $teamIds, roleIds: $roleIds, labelIds: $labelIds, projectStatusesBackend: $projectStatusesBackend) {\n      id\n      availableMinutesTotal\n      scheduledMinutesTotal\n      scheduledProjectTimeMinutes\n      scheduledNonProjectTimeMinutes\n      reportedTotal\n      assignedTasksForecastTotal\n      overTimeMinutesTotal\n      billableMinutesRegisteredTotal\n      billableMinutesPlannedTotal\n      utilizationListData {\n        id\n        name\n        profilePictureId\n        profilePictureDefaultId\n        roleName\n        availableMinutes\n        scheduledMinutes\n        scheduledNonProjectTimeMinutes\n        scheduledProjectTimeMinutes\n        reported\n        billableMinutesRegistered\n        billableMinutesPlanned\n        cardMinutesPlanned\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "eeb6c55023c02a56ad9a506f4b1621d4";

export default node;
